import { IDistributionVote } from '../interfaces/IDistributionVote';
import { IHAChangeCandidate } from '../interfaces/IHAChangeCandidate';
import { IHAChangePollingCandidate } from '../interfaces/IHAChangePollingCandidate';
import { IHAChangePollingPlace } from '../interfaces/IHAChangePollingPlace';
import { IHAStaticCandidate } from '../interfaces/IHAStaticCandidate';

export class CandidateCount {

  private readonly _haStaticCandidate: IHAStaticCandidate;
  private readonly _haChangeCandidate: IHAChangeCandidate;
  private readonly _haChangePollingPlaces: IHAChangePollingPlace[];
  private readonly _totalFirstPrefCount: number;
  private readonly _totalTwoCandidatePref: number | null;

  private totalPollingPlaceFormalVotesValue = 0;
  private totalPollingPlaceTwoCandidatePrefValue = 0;
  private totalPollingPlaceTwoPartyPrefValue = 0;
  private votePercentValue = 0;


  private previousFirstPrefVotesValue = 0;

  constructor(
    haStaticCandidate: IHAStaticCandidate,
    haChangeCandidate: IHAChangeCandidate,
    haChangePollingPlaces: IHAChangePollingPlace[],
    totalFirstPrefCount: number,
 
    totalTwoCandidatePref: number | null
  ) {
    this._haStaticCandidate = haStaticCandidate;
    this._haChangeCandidate = haChangeCandidate;
    this._haChangePollingPlaces = haChangePollingPlaces;
    this._totalFirstPrefCount = totalFirstPrefCount;
    this._totalTwoCandidatePref = totalTwoCandidatePref;
  }

  public afterInit(): void {
    // calc totals here

    const tmpTotals = this._haChangePollingPlaces.map(pollingPlace => {
      const value = pollingPlace.pollingCandidates.find(x => x.candidateId === this._haStaticCandidate.candidateId);
      return {
        formalVotes: value ? +value.formalVotes : 0,
        twoCandidatePref: value && value.twoCandidatePref ? +value.twoCandidatePref : 0,
        twoPartyPref: value && value.twoPartyPref ? +value.twoPartyPref : 0
      };
    });
    this.totalPollingPlaceFormalVotesValue = tmpTotals.reduce((sum, current) => sum + current.formalVotes, 0);
    this.totalPollingPlaceTwoCandidatePrefValue = tmpTotals.reduce((sum, current) => sum + current.twoCandidatePref, 0);
    this.totalPollingPlaceTwoPartyPrefValue = tmpTotals.reduce((sum, current) => sum + current.twoPartyPref, 0);

  }

  public get twoCPDeclarationVotes(): number | null {
    return this._haChangeCandidate.twoCandidatePrefDeclarationVotes;
  }

  public get candidateId(): number {
    return this._haStaticCandidate.candidateId;
  }

  /**
   * Ballot / change candidate id on the results JSON (often 1…n). Use when matching
   * declaration or absent rows that use this id instead of static profile candidateId.
   */
  public get changeCandidateId(): number {
    return this._haChangeCandidate.candidateId;
  }

  public get totalPollingPlaceFormalVotes(): number {
    return this.totalPollingPlaceFormalVotesValue;
  }

  public get totalPollingPlaceTwoCandidatePrefVotes(): number {
    return this.totalPollingPlaceTwoCandidatePrefValue + (this.twoCPDeclarationVotes ?? 0);
  }

  public get totalPollingPlaceTwoPartyPrefVotes(): number {
    return this.totalPollingPlaceTwoPartyPrefValue;
  }

  public get candidateName(): string {
    return this._haStaticCandidate.candidateName;
  }

  public get partyId(): string {
    return this._haStaticCandidate.partyId;
  }

  public get partyName(): string {
    return this._haStaticCandidate.partyName;
  }

  public get colourCode(): string {
    return this._haStaticCandidate.colourCode;
  }

  public get gender(): string {
    return this._haStaticCandidate.gender;
  }

  public get wasPreviousMember(): boolean {
    // return this._halcHistoryCandidate ? this._haStaticCandidate.candidateName === this._halcHistoryCandidate.candidateName
    //   && this._halcHistoryCandidate.isMember : false;

    return false;
  }

  public get ordinaryVoteCount(): number {
    return this._haChangeCandidate.ordinaryVotes;
  }

  public get declarationVoteCount(): number {
    return this._haChangeCandidate.declarationVotes;
  }

  public get votePercent(): number {
    return this.votePercentValue;
  }

  public get firstPrefShare(): number {
    return this._totalFirstPrefCount > 0 ? ((this.ordinaryVoteCount + this.declarationVoteCount) / this._totalFirstPrefCount) * 100 : 0;
  }

  public get totalFirstPrefCount(): number {
    return this._totalFirstPrefCount;
  }

  public get firstPrefChange(): number | null {
    return 0;
  }

  public get previousFirstPrefVotes(): number {
    return this.previousFirstPrefVotesValue;
  }

  public get twoCPVotePercent(): number | null {
    if (this._totalTwoCandidatePref === 0 || this._totalTwoCandidatePref === null) {
      return null;
    }
    return (this.totalPollingPlaceTwoCandidatePrefVotes / this._totalTwoCandidatePref) * 100;
  }

  public get distributionVotes(): IDistributionVote[] | null {
    return this._haChangeCandidate.distributionVotes;
  }
}
